import * as React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

export interface CardProps extends React.ComponentProps<'div'> {}

export interface CardHeaderProps extends React.ComponentProps<'div'> {
  /** 是否有 CardAction 子组件 */
  hasAction?: boolean;
  /** 是否显示底部边框 */
  withBorderBottom?: boolean;
}

export interface CardFooterProps extends React.ComponentProps<'div'> {
  /** 是否显示顶部边框 */
  withBorderTop?: boolean;
}

function Card({ className, ...props }: CardProps) {
  return (
    <div
      data-slot="card"
      className={classNames(styles.card, className)}
      {...props}
    />
  );
}

function CardHeader({
  className,
  hasAction,
  withBorderBottom,
  ...props
}: CardHeaderProps) {
  return (
    <div
      data-slot="card-header"
      className={classNames(
        styles.cardHeader,
        hasAction && styles.hasAction,
        withBorderBottom && styles.withBorderBottom,
        className,
      )}
      {...props}
    />
  );
}

function CardTitle({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <h2
      data-slot="card-title"
      className={classNames(styles.cardTitle, className)}
      {...props}
    />
  );
}

function CardDescription({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-description"
      className={classNames(styles.cardDescription, className)}
      {...props}
    />
  );
}

function CardAction({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-action"
      className={classNames(styles.cardAction, className)}
      {...props}
    />
  );
}

function CardContent({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-content"
      className={classNames(styles.cardContent, className)}
      {...props}
    />
  );
}

function CardFooter({
  className,
  withBorderTop,
  ...props
}: CardFooterProps) {
  return (
    <div
      data-slot="card-footer"
      className={classNames(
        styles.cardFooter,
        withBorderTop && styles.withBorderTop,
        className,
      )}
      {...props}
    />
  );
}

function CardGradientText({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-gradient-text"
      className={classNames(styles.cardGradientText, className)}
      {...props}
    />
  );
}

export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardAction,
  CardDescription,
  CardContent,
  CardGradientText,
};

export default Card;
